import { createApp } from 'vue'
import PersonalFundraisingDashboardMenu from './PersonalFundraisingDashboardMenu'

const el = '.kb-component--personal-fundraising-dashboard-menu'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((menuDOM) => {
            const editUrl = menuDOM.dataset.editUrl || null
            const qrCodeUrl = menuDOM.dataset.qrCodeUrl || null
            const livestreamUrl = menuDOM.dataset.livestreamUrl || null

            const component = createApp(PersonalFundraisingDashboardMenu, {
                editUrl,
                qrCodeUrl,
                livestreamUrl
            }).use(Store)
            component.mount(menuDOM)
        })
    }
}
